/**
 * Garde-fou des envois Storage : jamais de fichier sous `undefined/` ou `null/`.
 *
 * D'anciennes versions des apps ont écrit 17 092 photos sous `undefined/…`
 * quand le parc de l'utilisateur n'était pas encore chargé (`${zooId}` valait
 * `undefined`). Ces fichiers échappaient au cloisonnement par parc des règles
 * Storage (docs/handoff/2026-11-02-ranger-fichiers-undefined-storage.md).
 * Un chemin dont le premier segment est vide, `undefined` ou `null` est donc
 * refusé avant l'envoi : l'appelant garde sa photo et peut réessayer une fois
 * le parc connu.
 */

export const STORAGE_PATH_WITHOUT_PARK = "storage/path-without-park";

const MISSING_SEGMENTS = new Set(["", "undefined", "null"]);

/** Vrai si le chemin Storage commence par un parc manquant (`undefined/…`, `null/…`, `/…`). */
export function storagePathLacksPark(fullPath) {
  if (typeof fullPath !== "string") return true;
  return MISSING_SEGMENTS.has(fullPath.split("/")[0].trim());
}

export function createStoragePathWithoutParkError(fullPath) {
  const message = `Envoi refusé : le parc n'est pas encore connu (${fullPath}). / Upload refused: the park is not known yet.`;
  return Object.assign(new Error(message), { code: STORAGE_PATH_WITHOUT_PARK });
}

export const isStoragePathWithoutParkError = (error) => error?.code === STORAGE_PATH_WITHOUT_PARK;
